export enum BroadcastMessageDialogLengths {
  MESSAGE_MIN_LENGTH = 10,
  MESSAGE_MAX_LENGTH = 4000
}
